import { AxiosError } from 'axios';
import { ISuccsessResponse } from './types/uiTypes';
import { ITreeNode } from './types/commonTypes';
import { IGroupAlerts, ISelectGroupState } from './types/alertsTypes';
import { statusCode } from './constants';
import { roleIds } from '../config';

export const isAuthenticated = (): boolean => {
  const isAuthSet = getCookie("isAuthenticated");
  return isAuthSet == "true";
};

export const getUsername = (): string => {
  return getCookie('userName');
}

export const getRoleName = (): string => {
  return getCookie('roleName');
}

export function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function deleteCookies() {
  var cookies = document.cookie.split("; ");
  for (var c = 0; c < cookies.length; c++) {
    var d = window.location.hostname.split(".");
    while (d.length > 0) {
      var cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
      var p = location.pathname.split('/');
      document.cookie = cookieBase + '/';
      while (p.length > 0) {
        document.cookie = cookieBase + p.join('/');
        p.pop();
      };
      d.shift();
    }
  }
}

export const getTokenExpirationTime = (): number => {
  const tokenExpirationTime = decodeURIComponent(getCookie('exp'));
  if (tokenExpirationTime) {
    return parseInt(tokenExpirationTime) * 1000;
  }
  return null;
}

export const getCurrentTime = (): number => {
  return new Date().getTime();
}

export const isTokenExpired = (): boolean => {
  const tokenExpirationTime = getTokenExpirationTime();

  if (tokenExpirationTime === null)
    return false;

  const currentTime = getCurrentTime();
  return tokenExpirationTime < currentTime;
}

const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

export const getRoleNameById = (roleId) => {
  for (const [roleName, id] of Object.entries(roleIds)) {
    if (id === roleId) {
      return capitalize(roleName);
    }
  }
  return 'Unknown Role';
};

export const getRoleIdByName = (roleName) => {
  const normalizedRoleName = roleName.toLowerCase();
  return roleIds[normalizedRoleName] || 'Unknown Role ID';
};


// TODO: Backend Tech debt- check if all the APIs are returning correct status code on success/failure then modify below code to check on the basis of status code

export const SUCCESS_IDENTIFIER: string = 'successfully';

export const isSuccessResponse = (response: AxiosError | ISuccsessResponse): boolean => {
  return response?.message?.toLowerCase().includes(SUCCESS_IDENTIFIER);
}

export const isUnauthorisedError = (responseData: number): boolean => {
  return responseData == statusCode.unauthorised;
}

export const getAllValuesWithLabels = (nodes: ITreeNode[], selectGroupState: ISelectGroupState): IGroupAlerts[] => {
  let result: IGroupAlerts[] = [];
  function traverse(node) {
    result.push({
      id: node.value || node.id,
      displayName: node.label || node.displayName,
    });
    if (selectGroupState?.selectAllChecked) {
      if (node.children && node.children.length > 0) {
        for (const child of node.children) {
          traverse(child);
        }
      }
    }
  }
  for (const node of nodes) {
    traverse(node);
  }
  return result;
};

export const validateEmail=(email:string):boolean=>{
    const emailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailFormat.test(email);
}

export const isDirectAdmin = ():boolean => {
  const orgId = getCookie('organizationId');
  const groupId = getCookie('groupId');
  return orgId === groupId;
}